module.exports = __webpack_public_path__ + "assets/4ff2d93fd22541ddf08e43e0b4c5cda7.svg";